// // import React, { useState, useEffect } from "react";
// // import { useAuthState } from "react-firebase-hooks/auth";
// // import auth from "../../firebase.init";

// // const FeaturesSection = () => {
// //   const [user, loading, error] = useAuthState(auth);
// //   const [features, setFeatures] = useState([]);
// //   const [isLoading, setIsLoading] = useState(true);
// //   const [apiError, setApiError] = useState(null);

// //   // Fetch features data from API
// //   useEffect(() => {
// //     const fetchFeaturesData = async () => {
// //       try {
// //         setIsLoading(true);
// //         const response = await fetch(
// //           "https://octoberfour-60f2c682a1d1.herokuapp.com/api/features-section"
// //         );

// //         if (!response.ok) {
// //           throw new Error(`HTTP error! Status: ${response.status}`);
// //         }

// //         const result = await response.json();

// //         if (result.success) {
// //           setFeatures(result.data);
// //         } else {
// //           setApiError(result.message || "Failed to fetch features data");
// //         }
// //       } catch (err) {
// //         console.error("Error fetching features data:", err);
// //         setApiError("Network error or server not responding");
// //       } finally {
// //         setIsLoading(false);
// //       }
// //     };
// //     fetchFeaturesData();
// //   }, []);

// //   // Loading state
// //   if (isLoading) {
// //     return <div className="text-center py-5"></div>;
// //   }

// //   // Error state
// //   if (apiError) {
// //     return (
// //       <div className="alert alert-danger text-center py-5" role="alert">
// //         <h4>Error Loading Features</h4>
// //         <p>{apiError}</p>
// //         <button
// //           className="btn btn-outline-danger"
// //           onClick={() => window.location.reload()}
// //         >
// //           Retry
// //         </button>
// //       </div>
// //     );
// //   }

// //   // Filter active features only
// //   const activeFeatures = features.filter((feature) => feature.isActive);

// //   // If no active features data, don't render anything
// //   if (!activeFeatures || activeFeatures.length === 0) {
// //     return null;
// //   }

// //   return (
// //     // <>
// //     //   <div className="features-section-2 pt-100 pb-70">
// //     //     <div className="container">
// //     //       <div className="row">
// //     //         {activeFeatures.map((feature, index) => (
// //     //           <div
// //     //             key={feature._id || index}
// //     //             className="col-xl-3 col-lg-6 col-sm-6"
// //     //           >
// //     //             <div
// //     //               className="feature-box"
// //     //               data-aos="fade-up"
// //     //               data-aos-delay={100 * (index + 1)}
// //     //             >
// //     //               <span>{feature.category || "AI Features"}</span>
// //     //               <div className="icon">
// //     //                 {feature.icon ? (
// //     //                   // Check if icon is a URL or a class
// //     //                   feature.icon.startsWith("http") ? (
// //     //                     <img
// //     //                       src={feature.icon}
// //     //                       alt={feature.title}
// //     //                       className="feature-image"
// //     //                       onError={(e) => {
// //     //                         e.target.onerror = null;
// //     //                         e.target.style.display = "none";
// //     //                         e.target.parentNode.innerHTML =
// //     //                           '<div class="feature-placeholder"><i className="fi fi-tr-image-slash"></i></div>';
// //     //                       }}
// //     //                     />
// //     //                   ) : (
// //     //                     <div className="feature-icon">
// //     //                       <i className={feature.icon}></i>
// //     //                     </div>
// //     //                   )
// //     //                 ) : (
// //     //                   <div className="feature-placeholder">
// //     //                     <i className="fi fi-tr-image-slash" />
// //     //                   </div>
// //     //                 )}
// //     //               </div>
// //     //               <h3>{feature.title}</h3>
// //     //               <p>{feature.description}</p>
// //     //             </div>
// //     //           </div>
// //     //         ))}
// //     //       </div>
// //     //     </div>
// //     //   </div>

// //     //   <style jsx>{`
// //     //     .feature-image {
// //     //       width: 60px;
// //     //       height: 60px;
// //     //       object-fit: cover;
// //     //       border-radius: 50%;
// //     //     }

// //     //     .feature-icon {
// //     //       width: 90px;
// //     //       height: 90px;
// //     //       display: flex;
// //     //       align-items: center;
// //     //       justify-content: center;
// //     //       font-size: 30px;
// //     //       color: #555;
// //     //     }

// //     //     .feature-placeholder {
// //     //       width: 60px;
// //     //       height: 60px;
// //     //       display: flex;
// //     //       align-items: center;
// //     //       justify-content: center;
// //     //       background-color: #f0f0f0;
// //     //       border-radius: 50%;
// //     //       color: #888;
// //     //     }

// //     //     .feature-placeholder i {
// //     //       font-size: 24px;
// //     //     }
// //     //   `}</style>
// //     // </>

// //     <><section class="service-section pb_120 centred">
// //             <div class="auto-container">
// //                 <div class="sec-title mb_60">
// //                     <span class="sub-title">AI Content</span>
// //                     <h2>Industries for AI Content</h2>
// //                 </div>
// //                 <div class="row clearfix">
// //                     <div class="col-lg-4 col-md-6 col-sm-12 service-block">
// //                         <div class="service-block-one">
// //                             <div class="inner-box">
// //                                 <div class="icon-box"><i class="icon-22"></i></div>
// //                                 <h3><a href="index-2.html">Blog & News Article</a></h3>
// //                                 <p>With our AI your the can makes the never before seen images fores New Year card more the public reviews our </p>
// //                             </div>
// //                         </div>
// //                     </div>
// //                     <div class="col-lg-4 col-md-6 col-sm-12 service-block">
// //                         <div class="service-block-one">
// //                             <div class="inner-box">
// //                                 <div class="icon-box"><i class="icon-23"></i></div>
// //                                 <h3><a href="index-2.html">Ecommerce Description</a></h3>
// //                                 <p>With our AI your the can makes the never before seen images fores New Year card more the public reviews our </p>
// //                             </div>
// //                         </div>
// //                     </div>
// //                     <div class="col-lg-4 col-md-6 col-sm-12 service-block">
// //                         <div class="service-block-one">
// //                             <div class="inner-box">
// //                                 <div class="icon-box"><i class="icon-24"></i></div>
// //                                 <h3><a href="index-2.html">Social Media Post</a></h3>
// //                                 <p>With our AI your the can makes the never before seen images fores New Year card more the public reviews our </p>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </section></>
// //   );
// // };

// // export default FeaturesSection;

// import React, { useState, useEffect } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";

// const FeaturesSection = () => {
//   const [user, loading, error] = useAuthState(auth);
//   const [features, setFeatures] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   // Fetch features data from API
//   useEffect(() => {
//     const fetchFeaturesData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch(
//           "https://octoberfour-60f2c682a1d1.herokuapp.com/api/features-section"
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();

//         if (result.success) {
//           setFeatures(result.data);
//         } else {
//           setApiError(result.message || "Failed to fetch features data");
//         }
//       } catch (err) {
//         console.error("Error fetching features data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchFeaturesData();
//   }, []);

//   // Loading state
//   if (isLoading) {
//     return <div className="text-center py-5">Loading...</div>;
//   }

//   // Error state
//   if (apiError) {
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading Features</h4>
//         <p>{apiError}</p>
//         <button
//           className="btn btn-outline-danger"
//           onClick={() => window.location.reload()}
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }

//   // Filter active features only
//   const activeFeatures = features.filter((feature) => feature.isActive);

//   if (!activeFeatures || activeFeatures.length === 0) {
//     return null;
//   }

//   return (
//     // <section className="service-section pb_120 centred">
//     //   <div className="auto-container">
//     //     <div className="sec-title mb_60">
//     //       <span className="sub-title">Popular Features</span>
//     //       <h2>Explore Our Features</h2>
//     //     </div>
//     //     <div className="row clearfix">
//     //       {activeFeatures.map((feature, index) => (
//     //         <div
//     //           key={feature._id || index}
//     //           className="col-lg-4 col-md-6 col-sm-12 service-block"
//     //         >
//     //           <div className="service-block-one">
//     //             <div className="inner-box">
//     //               <div className="icon-box">
//     //                 {feature.icon ? (
//     //                   <img
//     //                     src={feature.icon}
//     //                     alt={feature.title}
//     //                     className="feature-icon-img"
//     //                     onError={(e) => {
//     //                       e.target.onerror = null;
//     //                       e.target.style.display = "none";
//     //                       e.target.parentNode.innerHTML =
//     //                         '<div class="feature-placeholder"><i class="fi fi-tr-image-slash"></i></div>';
//     //                     }}
//     //                   />
//     //                 ) : (
//     //                   <div className="feature-placeholder">
//     //                     <i className="fi fi-tr-image-slash" />
//     //                   </div>
//     //                 )}
//     //               </div>
//     //               <h3>{feature.title}</h3>
//     //               <p>{feature.description}</p>
//     //             </div>
//     //           </div>
//     //         </div>
//     //       ))}
//     //     </div>
//     //   </div>

//     //   {/* Styles */}
//     //   <style jsx>{`
//     //     .feature-icon-img {
//     //       width: 60px;
//     //       height: 60px;
//     //       object-fit: contain;
//     //     }
//     //     .feature-placeholder {
//     //       width: 60px;
//     //       height: 60px;
//     //       display: flex;
//     //       align-items: center;
//     //       justify-content: center;
//     //       background-color: #f0f0f0;
//     //       border-radius: 50%;
//     //       color: #888;
//     //     }
//     //     .feature-placeholder i {
//     //       font-size: 24px;
//     //     }
//     //   `}</style>
//     // </section>

//     <>  <section className="choose-area pt-140">
//   <div className="container">
//     <div className="row justify-content-center">
//       <div className="col-12">
//         <div className="section-area text-center mb-50">
//           <span className="section-subtitle tp_fade_left">Popular Features</span>
//           <h2 className="section-title tp_title_slideup mb-0">Explore Our Features</h2>
//         </div>
//       </div>
//     </div>
//     <div className="row">
//       <div className="col-xl-3 col-lg-4 col-md-6 tp_fade_left" data-fade-from="left">
//         <div className="choose-item mb-30">
//           <span className="choose-item-count">01</span>
//           <div className="choose-item-img">
//             <img src="assets/images/choose/1.png" alt="Image Not Found" />
//           </div>
//           <div className="choose-item-content">
//             <h5 className="choose-item-content-title"><a href="#">Fast Text Generate</a></h5>
//             <p>Lorem Ipsum is simply dummy text of the printing and typesetting.</p>
            
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6 tp_fade_left" data-fade-from="left" data-delay=".8">
//         <div className="choose-item mb-30">
//           <span className="choose-item-count">02</span>
//           <div className="choose-item-img">
//             <img src="assets/images/choose/2.png" alt="Image Not Found" />
//           </div>
//           <div className="choose-item-content">
//             <h5 className="choose-item-content-title"><a href="#">High Quality Content</a></h5>
//             <p>Lorem Ipsum is simply dummy text of the printing and typesetting.</p>
           
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6 tp_fade_left" data-fade-from="left" data-delay="1.1">
//         <div className="choose-item mb-30">
//           <span className="choose-item-count">03</span>
//           <div className="choose-item-img">
//             <img src="assets/images/choose/3.png" alt="Image Not Found" />
//           </div>
//           <div className="choose-item-content">
//             <h5 className="choose-item-content-title"><a href="#">40+ Language...</a></h5>
//             <p>Lorem Ipsum is simply dummy text of the printing and typesetting.</p>
           
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6 tp_fade_left" data-fade-from="left" data-delay="1.3">
//         <div className="choose-item mb-30">
//           <span className="choose-item-count">04</span>
//           <div className="choose-item-img">
//             <img src="assets/images/choose/4.png" alt="Image Not Found" />
//           </div>
//           <div className="choose-item-content">
//             <h5 className="choose-item-content-title"><a href="#">24/7 Hours Support</a></h5>
//             <p>Lorem Ipsum is simply dummy text of the printing and typesetting.</p>
            
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>
// </>
//   );
// };

// export default FeaturesSection;


// import React, { useState, useEffect } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";

// const FeaturesSection = () => {
//   const [user, loading, error] = useAuthState(auth);
//   const [features, setFeatures] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   // Fetch features data from API
//   useEffect(() => {
//     const fetchFeaturesData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/features-section");
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//         const result = await response.json();
//         if (result.success) setFeatures(result.data);
//         else setApiError(result.message || "Failed to fetch features data");
//       } catch (err) {
//         console.error("Error fetching features data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchFeaturesData();
//   }, []);

//   if (isLoading) return <div className="text-center py-5">Loading...</div>;
//   if (apiError)
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading Features</h4>
//         <p>{apiError}</p>
//         <button className="btn btn-outline-danger" onClick={() => window.location.reload()}>
//           Retry
//         </button>
//       </div>
//     );

//   const activeFeatures = features.filter((feature) => feature.isActive);
//   if (!activeFeatures.length) return null;

//   return (
//     // <section className="choose-area pt-140">
//     //   <div className="container">
//     //     <div className="row justify-content-center">
//     //       <div className="col-12">
//     //         <div className="section-area text-center mb-50">
//     //           <span className="section-subtitle tp_fade_left">Popular Features</span>
//     //           <h2 className="section-title tp_title_slideup mb-0">Explore Our Features</h2>
//     //         </div>
//     //       </div>
//     //     </div>
//     //     <div className="row">
//     //       {activeFeatures.map((feature, index) => (
//     //         <div
//     //           key={feature._id || index}
//     //           className="col-xl-3 col-lg-4 col-md-6 tp_fade_left"
//     //           data-fade-from="left"
//     //           data-delay={0.3 * (index + 1)}
//     //         >
//     //           <div className="choose-item mb-30">
//     //             <span className="choose-item-count">{`0${index + 1}`}</span>
//     //             <div className="choose-item-img">
//     //               {feature.icon ? (
//     //                 <img
//     //                   src={feature.icon}
//     //                   alt={feature.title}
//     //                   onError={(e) => {
//     //                     e.target.onerror = null;
//     //                     e.target.style.display = "none";
//     //                     e.target.parentNode.innerHTML =
//     //                       '<div class="feature-placeholder"><i class="fi fi-tr-image-slash"></i></div>';
//     //                   }}
//     //                 />
//     //               ) : (
//     //                 <div className="feature-placeholder">
//     //                   <i className="fi fi-tr-image-slash" />
//     //                 </div>
//     //               )}
//     //             </div>
//     //             <div className="choose-item-content">
//     //               <h5 className="choose-item-content-title">
//     //                 <a href={feature.link || "#"}>{feature.title}</a>
//     //               </h5>
//     //               <p>{feature.description}</p>
//     //             </div>
//     //           </div>
//     //         </div>
//     //       ))}
//     //     </div>
//     //   </div>
//     // </section>

//     <>       <section className="gt-feature-benefit-section section-padding pt-50">
//   <div className="container">
//     <div className="gt-section-title style-3 text-center">
//       <h6 className="wow fadeInUp tt-capitalize">key features</h6>
//       <h2 className="char-animation">
//         Boostly key benefits
//       </h2>
     
//     </div>
  
//   <div className="container">
//     <div className="row g-4">
//       <div className="col-xl-4 col-lg-6 col-md-6">
//         <div className="service-single-card">
//           <div className="icon">
//             <img src="assets/img/service/icon-1.png" alt="img" />
//           </div>
//           <div className="content">
//             <h3><a href="service-details.html">Digital Marketing</a></h3>
//             <p>Lorem dolor amet consectetur read adipiscing any more elit. Lorem dolor.</p>
//             <a href="service-details.html" className="arrow-btn"><i className="fa-solid fa-arrow-right" /></a>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-4 col-lg-6 col-md-6">
//         <div className="service-single-card">
//           <div className="icon">
//             <img src="assets/img/service/icon-2.png" alt="img" />
//           </div>
//           <div className="content">
//             <h3><a href="service-details.html">SEO Analytics</a></h3>
//             <p>Lorem dolor amet consectetur read adipiscing any more elit. Lorem dolor.</p>
//             <a href="service-details.html" className="arrow-btn"><i className="fa-solid fa-arrow-right" /></a>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-4 col-lg-6 col-md-6">
//         <div className="service-single-card">
//           <div className="icon">
//             <img src="assets/img/service/icon-3.png" alt="img" />
//           </div>
//           <div className="content">
//             <h3><a href="service-details.html">Social Marketing</a></h3>
//             <p>Lorem dolor amet consectetur read adipiscing any more elit. Lorem dolor.</p>
//             <a href="service-details.html" className="arrow-btn"><i className="fa-solid fa-arrow-right" /></a>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>


//   </div>
// </section>
// </>
//   );
// };

// export default FeaturesSection;


// import React, { useState, useEffect } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";

// const FeaturesSection = () => {
//   const [user, loading, error] = useAuthState(auth);
//   const [features, setFeatures] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   // Fetch features data from API
//   useEffect(() => {
//     const fetchFeaturesData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/features-section");
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//         const result = await response.json();
//         if (result.success) setFeatures(result.data);
//         else setApiError(result.message || "Failed to fetch features data");
//       } catch (err) {
//         console.error("Error fetching features data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchFeaturesData();
//   }, []);

//   if (isLoading) return <div className="text-center py-5">Loading...</div>;
//   if (apiError)
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading Features</h4>
//         <p>{apiError}</p>
//         <button className="btn btn-outline-danger" onClick={() => window.location.reload()}>
//           Retry
//         </button>
//       </div>
//     );

//   const activeFeatures = features.filter((feature) => feature.isActive);
//   if (!activeFeatures.length) return null;

//   return (
//     // <>
//     //   <section className="gt-feature-benefit-section section-padding pt-50">
//     //     <div className="container">
//     //       <div className="gt-section-title style-3 text-center">
//     //         <h6 className="wow fadeInUp tt-capitalize">key features</h6>
//     //         <h2 className="char-animation">Boostly key benefits</h2>
//     //       </div>

//     //       <div className="container">
//     //         <div className="row g-4">
//     //           {activeFeatures.map((feature, index) => (
//     //             <div className="col-xl-4 col-lg-6 col-md-6" key={feature._id || index}>
//     //               <div className="service-single-card">
//     //                 <div className="icon">
//     //                   {feature.icon ? (
//     //                     <img
//     //                       src={feature.icon}
//     //                       alt={feature.title}
//     //                       onError={(e) => {
//     //                         e.target.onerror = null;
//     //                         e.target.src = "assets/img/service/default-icon.png";
//     //                       }}
//     //                     />
//     //                   ) : (
//     //                     <img src="assets/img/service/default-icon.png" alt="default icon" />
//     //                   )}
//     //                 </div>
//     //                 <div className="content">
//     //                   <h3>
//     //                     <a href={feature.link || "#"}>{feature.title}</a>
//     //                   </h3>
//     //                   <p>{feature.description}</p>
                    
//     //                 </div>
//     //               </div>
//     //             </div>
//     //           ))}
//     //         </div>
//     //       </div>
//     //     </div>
//     //   </section>
//     // </>

//     <><section className="features-area-two pt-130 rel z-1">
//   <div className="container">
//     <div className="row justify-content-center">
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="feature-item-two mt-60 wow fadeInUp delay-0-2s">
//           <div className="icon"><i className="fas fa-check" /></div>
//           <h4>249+ UI <br />Components</h4>
//           <p>Sit amet conse adipiscin elitec eiusmod tempors incidide sesy labore dolore another</p>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="feature-item-two color-two wow fadeInUp delay-0-4s">
//           <div className="icon"><i className="fas fa-check" /></div>
//           <h4>5630+ <br />Web Templates</h4>
//           <p>Sit amet conse adipiscin elitec eiusmod tempors incidide sesy labore dolore another</p>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="feature-item-two color-three mt-60 wow fadeInUp delay-0-6s">
//           <div className="icon"><i className="fas fa-check" /></div>
//           <h4>9562+ <br />Digital Assets</h4>
//           <p>Sit amet conse adipiscin elitec eiusmod tempors incidide sesy labore dolore another</p>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="feature-item-two color-four wow fadeInUp delay-0-8s">
//           <div className="icon"><i className="fas fa-check" /></div>
//           <h4>4563+ <br />Custome Addon</h4>
//           <p>Sit amet conse adipiscin elitec eiusmod tempors incidide sesy labore dolore another</p>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>
// </>
//   );
// };

// export default FeaturesSection;


// import React, { useState, useEffect } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";

// const FeaturesSection = () => {
//   const [user, loading, error] = useAuthState(auth);
//   const [features, setFeatures] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   // Fetch features data from API
//   useEffect(() => {
//     const fetchFeaturesData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/features-section");
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//         const result = await response.json();
//         if (result.success) setFeatures(result.data);
//         else setApiError(result.message || "Failed to fetch features data");
//       } catch (err) {
//         console.error("Error fetching features data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchFeaturesData();
//   }, []);

//   if (isLoading) return <div className="text-center py-5">Loading...</div>;
//   if (apiError)
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading Features</h4>
//         <p>{apiError}</p>
//         <button className="btn btn-outline-danger" onClick={() => window.location.reload()}>
//           Retry
//         </button>
//       </div>
//     );

//   const activeFeatures = features.filter((feature) => feature.isActive);
//   if (!activeFeatures.length) return null;

//   return (
//     // <section className="features-area-two pt-130 rel z-1">
//     //   <div className="container">
//     //     <div className="row justify-content-center">
//     //       {activeFeatures.map((feature, index) => {
//     //         // Optional dynamic color class assignment
//     //         const colorClasses = ["", "color-two", "color-three", "color-four"];
//     //         const colorClass = colorClasses[index % colorClasses.length];
//     //         const delay = `delay-0-${2 + index * 2}s`;

//     //         return (
//     //           <div className="col-xl-3 col-lg-4 col-md-6" key={feature._id || index}>
//     //             <div className={`feature-item-two ${colorClass} ${index % 2 !== 0 ? "mt-60" : ""} wow fadeInUp ${delay}`}>
//     //               <div className="icon">
//     //                 {feature.icon ? (
//     //                   <img
//     //                     src={feature.icon}
//     //                     alt={feature.title}
//     //                     onError={(e) => {
//     //                       e.target.onerror = null;
//     //                       e.target.src = "assets/img/service/default-icon.png";
//     //                     }}
//     //                   />
//     //                 ) : (
//     //                   <i className="fas fa-check" />
//     //                 )}
//     //               </div>
//     //               <h4>
//     //                 {feature.title?.split(" ").map((word, i) => (
//     //                   <React.Fragment key={i}>
//     //                     {i === 1 ? <br /> : null}
//     //                     {word}{" "}
//     //                   </React.Fragment>
//     //                 ))}
//     //               </h4>
//     //               <p>{feature.description}</p>
//     //             </div>
//     //           </div>
//     //         );
//     //       })}
//     //     </div>
//     //   </div>
//     // </section>

//     <> <section id="services" className="services-area pt-130 pb-100 rel z-1">
//   <div className="container">
//     <div className="section-title text-center mb-55">
//       <span className="sub-title mb-15">Our Popular Services</span>
//       <h2>Amazing Web Design Service</h2>
//     </div>
//     <div className="row justify-content-center">
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="service-item wow fadeInUp delay-0-2s">
//           <div className="icon"><i className="fab fa-react" /></div>
//           <div className="content">
//             <h5><a href="service-details.html">React js Development</a></h5>
//             <p>Focus provide beautiful layout client look make import</p>
//             <a className="read-more" href="service-details.html">Read More <i className="fas fa-angle-double-right" /></a>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="service-item wow fadeInUp delay-0-4s">
//           <div className="icon"><i className="flaticon-data-transfer" /></div>
//           <div className="content">
//             <h5><a href="service-details.html">React Native Development</a></h5>
//             <p>Focus provide beautiful layout client look make import</p>
//             <a className="read-more" href="service-details.html">Read More <i className="fas fa-angle-double-right" /></a>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="service-item wow fadeInUp delay-0-6s">
//           <div className="icon"><i className="flaticon-optimization" /></div>
//           <div className="content">
//             <h5><a href="service-details.html">Jamstack Development</a></h5>
//             <p>Focus provide beautiful layout client look make import</p>
//             <a className="read-more" href="service-details.html">Read More <i className="fas fa-angle-double-right" /></a>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4 col-md-6">
//         <div className="service-item wow fadeInUp delay-0-8s">
//           <div className="icon"><i className="flaticon-coding" /></div>
//           <div className="content">
//             <h5><a href="service-details.html">Front-end development</a></h5>
//             <p>Focus provide beautiful layout client look make import</p>
//             <a className="read-more" href="service-details.html">Read More <i className="fas fa-angle-double-right" /></a>
//           </div>
//         </div>
//       </div>
     
    
     
  
//     </div>
//   </div>
// </section>
// </>
//   );
// };

// export default FeaturesSection;


import React, { useState, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";

const FeaturesSection = () => {
  const [user, loading, error] = useAuthState(auth);
  const [features, setFeatures] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  // Fetch features data from API
  useEffect(() => {
    const fetchFeaturesData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/features-section");
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const result = await response.json();
        if (result.success) setFeatures(result.data);
        else setApiError(result.message || "Failed to fetch features data");
      } catch (err) {
        console.error("Error fetching features data:", err);
        setApiError("Network error or server not responding");
      } finally {
        setIsLoading(false);
      }
    };
    fetchFeaturesData();
  }, []);

  if (isLoading) return <div className="text-center py-5">Loading...</div>;
  if (apiError)
    return (
      <div className="alert alert-danger text-center py-5" role="alert">
        <h4>Error Loading Features</h4>
        <p>{apiError}</p>
        <button
          className="btn btn-outline-danger"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );

  // Only show active features
  const activeFeatures = features.filter((feature) => feature.isActive);
  if (!activeFeatures.length) return null;

  return (
    <section className="cs_slider cs_style_1 cs_slider_gap_24">
      <div className="cs_bg_shape_1 cs_purple_bg cs_radius_15 position-absolute" />
      <div className="cs_height_125 cs_height_lg_80" />
      <div className="container position-relative z-1">
        <div className="cs_section_heading cs_style_1 cs_type_1 cs_mb_60">
          <div className="cs_section_heading_left">
            <h2 className="cs_section_title cs_fs_50 mb-0 wow fadeInLeft">
              Core Features of Our <br /> SEO Service
            </h2>
          </div>
          <div className="cs_section_heading_right wow fadeInRight">
            <p className="mb-0">
              We provide expert SEO solutions including keyword research, website optimization, and meta setup to boost rankings, increase organic traffic, and grow your business online. Our services focus on measurable results and long-term success for every client.
            </p>
          </div>
        </div>

        {/* Dynamic Features Grid */}
        <div className="row justify-content-center m-5 g-4">
          {activeFeatures.map((feature, index) => (
            <div className="col-lg-4 col-md-6 d-flex" key={feature._id || index}>
              <div className="cs_iconbox cs_style_1 cs_type_1 cs_heading_bg cs_center_column cs_radius_15 text-center w-100">
                <span className="cs_iconbox_icon cs_center cs_radius_15 cs_accent_bg cs_mb_28">
                  <img
                    src={feature.icon || "assets/img/icons/browser.svg"}
                    alt={feature.title}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "assets/img/icons/browser.svg";
                    }}
                  />
                </span>
                <div className="cs_iconbox_info">
                  <h3 className="cs_iconbox_title cs_fs_29 cs_normal cs_white_color">
                    {feature.title}
                  </h3>
                  <p className="cs_iconbox_subtitle cs_fs_18 cs_border_color cs_mb_17">
                    {feature.description}
                  </p>
                  {feature.link && (
                    <a
                      href={feature.link}
                      aria-label="Click to visit features page"
                      className="cs_iconbox_btn cs_semibold cs_white_color"
                    >
                      <span>Learn More</span>
                      <span className="cs_btn_icon cs_center">
                        <i className="fa-solid fa-arrow-right" />
                      </span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="cs_height_140 cs_height_lg_80" />
    </section>
  );
};

export default FeaturesSection;






